import { Tolls } from "@types";

type RouteSegment = {
  distance: number;
};

type FuelInfo = {
  initialFuel: number;
  tankCapacity: number;
  consumption: number;
};

export function CalcFuelStops(segments: RouteSegment[], fuelInfo: FuelInfo): Array<{ index: number; stops: number }> {
  const { initialFuel, tankCapacity, consumption } = fuelInfo;

  const initialRangeKm = initialFuel * consumption;
  const fullTankRangeKm = tankCapacity * consumption;

  const totalRouteDistance = segments.reduce((total, segment) => {
    const segmentDistanceKm = segment.distance / 1000;
    return total + segmentDistanceKm;
  }, 0);

  if (totalRouteDistance <= initialRangeKm) {
    return segments.map((_, index) => ({
      index,
      stops: 0,
    }));
  }

  let totalStopsNeeded = 0;
  let remainingDistance = totalRouteDistance - initialRangeKm;

  totalStopsNeeded = Math.ceil(remainingDistance / fullTankRangeKm);

  const refuelStops: number[] = [];
  let cumulativeDistance = 0;
  let nextRefuelDistance = initialRangeKm;

  for (let i = 0; i < segments.length; i++) {
    const segmentDistanceKm = segments[i].distance / 1000;
    cumulativeDistance += segmentDistanceKm;

    while (cumulativeDistance >= nextRefuelDistance && refuelStops.length < totalStopsNeeded) {
      refuelStops.push(i);
      nextRefuelDistance += fullTankRangeKm;
    }
  }

  const segmentsWithStops = segments.map((_, index) => {
    const stopsCount = refuelStops.filter((stopIndex) => stopIndex === index).length;
    return {
      index,
      stops: stopsCount,
    };
  });

  return segmentsWithStops;
}

export const CalcTools = (tools: Tolls[] | null) => {
  let total = 0;

  tools?.forEach((item) => {
    if (item.fares && item.fares.length > 0) {
      total += item.fares[0].price.value;
    }
  });

  return total;
};
